import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';
import { RouteComponentProps } from 'react-router';

import CompaniesStore from '../../../stores/companies/companies-store';
import { Spinner } from '../../../components';
import CompanyCard from '../company-card/company-card';
import CompanyTables from '../company-tables/company-tables';

interface MatchParams {
	id: string;
}

interface Props extends RouteComponentProps<MatchParams> {
	companiesStore?: CompaniesStore;
}

class CompanyContainer extends Component<Props, {}> {
	componentDidMount() {
		this.fetchCompany();
	}

	componentDidUpdate(prevProps: Props) {
		if (prevProps.match.params.id !== this.props.match.params.id) {
			this.fetchCompany();
		}
	}

	fetchCompany() {
		const companyId = Number(this.props.match.params.id);

		this.props.companiesStore.fetch(companyId);
		this.props.companiesStore.fetchUsers(companyId);
	}

	render() {
		const companyId = Number(this.props.match.params.id);
		const company = this.props.companiesStore.get(companyId);

		if (!company) {
			return <Spinner />;
		}

		return (
			<div className="company-container">
				<CompanyCard company={company} />
				<CompanyTables dispatchers={company.dispatchers} drivers={company.drivers} />
			</div>
		);
	}
}

export default inject('companiesStore')(observer(CompanyContainer));
